module.exports = __webpack_public_path__ + "static/media/Transaction-risk-engine create-transaction.67d24b90.png";